$(document).ready(function(){
  $('.product__media-list--').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.thumbnail-list--'
  });
  $('.thumbnail-list--').slick({
    slidesToShow:4,
    slidesToScroll: 1,
    asNavFor: '.product__media-list--',
    dots: true,
    centerMode: true,
    focusOnSelect: true
  });	
});
   
// $(document).ready(function() {
//   var interval = setInterval(checkMzFigure, 100);
//   function checkMzFigure() {
//     var productMediaContainer = $(".product-media-container");
//     if (productMediaContainer.length > 0 && productMediaContainer.find(".mz-figure").length > 0) {
//       clearInterval(interval);
//       updateImagealt();
//     }
//   }
//   function updateImagealt() {
//      $(".mz-lens img").each(function() {
//     $(this).attr("alt", "product-image");
//   }); 
//   }
// });